import type { IntlShape } from "react-intl";
import {
  DateFormatsTypes,
  MomentDate,
} from "../../../../../../components/Moment/Moment";
export class GetDatesHelper {
  //
  static getDates: (datesWithEvents: any, intl: any) => any = (
    datesWithEvents: Record<string, any>,
    intl: IntlShape
  ) => {
    const dates = datesWithEvents.map(date => {
      return {
        value: date.day,
        label: (
          <MomentDate dateFormat={DateFormatsTypes.DATE_MDD} value={date.day} />
        ),
      };
    });
    dates.push({
      value: "ALL",
      label: intl.formatMessage({
        id: "global-events-navigation-all-dates",
      }),
    });
    return dates;
  };
}
